import { Menu } from '@reach/menu-button';
import React from 'react';

export const AccountMenu: React.FC = ({ children }) => {
  return <Menu>{children}</Menu>;
};
